import type { SplitViewContentType } from '@saaga/shared/store/slices/split-view.slice'
import type { ChatParticipant, ChatPinnedMessage } from '@/components/chat/chat-header.interface'
import type { ChatToolCall } from '@/components/chat/chat-message.interface'
import { mockDomainOverviewData } from '@/components/split-view/domain-overview.mock'

export { createInitialMockConversation } from './chat-mock-conversation.helper'
export { generateMockResponse, generateThoughtContent } from './chat-mock-response-generator.helper'

export const mockParticipantList: ChatParticipant[] = [
  { id: 'user-1', name: 'John Doe', avatarUrl: undefined },
  { id: 'user-2', name: 'Jane Smith', avatarUrl: undefined },
  { id: 'user-3', name: 'SAAGA AI', avatarUrl: undefined },
]

export const mockPinnedMessageList: ChatPinnedMessage[] = [
  {
    id: 'pin-1',
    parentMessageId: 'pin-1',
    content: 'Remember to update the API documentation before the release.',
    pinnedBy: { id: 'user-2', name: 'Jane Smith', avatarUrl: undefined },
    pinnedAt: '2024-01-15T10:30:00Z',
    pageNumber: 1,
    pageSize: 200,
    itemRole: 'MESSAGE',
  },
]

export const MOCK_CURRENT_USER_ID = 'user-1'
export const MOCK_CONVERSATION_ID = 'conv-mock-1'

export const getContentTypeForTool = (toolName: string): SplitViewContentType => {
  if (toolName === 'domain_overview') {
    return 'domain-overview'
  }
  return 'tool-call'
}

export const getContentDataForTool = (toolCall: ChatToolCall): Record<string, unknown> => {
  if (toolCall.toolName === 'domain_overview') {
    return mockDomainOverviewData
  }
  return { toolCall }
}
